import React from 'react';
import { CellInfo } from 'react-table';
import FaIcon from '../FaIcon/FaIcon';

export const CheckSyncIcon = (cell: CellInfo): JSX.Element => {
   if (cell.value === null) return <>-</>;

   const iconName = cell.value ? 'check' : 'sync-alt';
   return <FaIcon icon={iconName} />;
};
